export enum Scope {
    CENSO = 'CENSO',
    CLOUDCODICE = 'CLOUDCODICE',
    SUBSCRIPTION = 'SUBSCRIPTION',
    DEVELOPER = 'DEVELOPER',
    DIAGNOSIS = 'DIAGNOSIS',
    NON_CLUSTERED = 'NON_CLUSTERED',
    SYSTEM = 'SYSTEM',
}
